import { render, staticRenderFns } from "./ShipperPage.vue?vue&type=template&id=fd1bbc86&scoped=true&"
import script from "./ShipperPage.vue?vue&type=script&lang=js&"
export * from "./ShipperPage.vue?vue&type=script&lang=js&"
import style0 from "./ShipperPage.vue?vue&type=style&index=0&id=fd1bbc86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1bbc86",
  null
  
)

export default component.exports